import { AibBlockLine, AibLineType } from "./interface";

/**
 * Creates a new block line with the specified type and blank content.
 *
 * @param lineType - The type of block line to create
 * @param blankT - The blank template value for initializing the block line
 * @returns AibBlockLine<T>
 */
export const newBlockLine = <T>(lineType: AibLineType, blankT: T): AibBlockLine<T> => {
  const ret: AibBlockLine<T> = {
    aifid: crypto.randomUUID(),
    lineType,
    left: [AibLineType.leftOnly, AibLineType.leftAndRight, AibLineType.leftCenterAndRight].includes(
      lineType,
    )
      ? blankT
      : null,
    center: [AibLineType.centerOnly, AibLineType.leftCenterAndRight].includes(lineType)
      ? blankT
      : null,
    right: [AibLineType.leftAndRight, AibLineType.leftCenterAndRight].includes(lineType)
      ? blankT
      : null,
    addBelow: true,
    canEdit: true,
    canMove: true,
    canRemove: true,
    canChangeType: true,
    coreTrafficLight: "BlankNotEvaluated",
  };
  return ret;
};
